import React from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

export default function EmployeeTable({ employees, employeeTypeOptions, onRowClick, onDelete, editingIndex }) {
  return (
    <TableContainer component={Paper} elevation={0} sx={tableContainerSx}>
      <Table aria-label='added employees table' stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>First name</TableCell>
            <TableCell>Last name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Employee type</TableCell>
            <TableCell>Department</TableCell>
            <TableCell>Location</TableCell>
            <TableCell>Language</TableCell>
            <TableCell align='right'>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {employees.map((emp, idx) => (
            <TableRow
              key={idx}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => onRowClick(idx)}
              selected={editingIndex === idx}
            >
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{emp.firstName}</TableCell>
              <TableCell>{emp.lastName}</TableCell>
              <TableCell>{emp.email}</TableCell>
              <TableCell>
                {employeeTypeOptions.find(et => et.value === emp.systemRole)?.label || emp.systemRole}
              </TableCell>
              <TableCell>{emp.department || '-'}</TableCell>
              <TableCell>{emp.country || '-'}</TableCell>
              <TableCell>{emp.language || '-'}</TableCell>
              <TableCell align='right'>
                <IconButton
                  size='small'
                  onClick={e => {
                    e.stopPropagation()
                    onDelete(idx)
                  }}
                >
                  <DeleteIcon fontSize='small' />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const tableContainerSx = {
  border: 'none',
  backgroundColor: 'transparent',
  mb: 3,
  mt: 3,
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  '& .MuiTableCell-head': {
    color: '#76767F',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    backgroundColor: 'transparent',
    padding: '12px 16px',
    textTransform: 'capitalize',
    borderBottom: '1px solid #EAECF0'
  },
  '& .MuiTableCell-body': {
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '##1B1B26',
    padding: '14px 16px',
    backgroundColor: 'transparent',
    borderBottom: '1px solid #EAECF0'
  },
  '& .MuiTableRow-root:last-child .MuiTableCell-body': {
    borderBottom: 'none'
  }
}
